<template>
	<div>
		<el-dialog :title="'新增标签'" :visible.sync="dialog_state" width="467px" @close="close" :top="'15vh'" :close-on-click-modal="false">
			<el-form ref="editProductParams" label-width="120px">
				<div v-if="tagItem===''">
					<el-form-item label="新增标签">
						<el-input v-model="newValue" size='mini' style="width: 200px;"></el-input>
					</el-form-item>
				</div>
				<div v-else>
					<el-form-item label="当前标签">
						<el-input v-model="tagItem.value" disabled size='mini' style="width: 200px;"></el-input>
					</el-form-item>
					<el-form-item label="新增子标签">
						<el-input v-model="newValue" size='mini' style="width: 200px;"></el-input>
					</el-form-item>
				</div>
				<div style="text-align: right;">
					<el-button size="small" type="warning" @click="submit">确定</el-button>
				</div>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				dialog_state:false,
				
				newValue:''
			}
		},
		props:{
			tagItem:{
				default:()=>{
					return {}
				}
			}
		},
		mounted(){
			this.$nextTick(()=>{
				this.dialog_state = true
			})
		},
		methods:{
			close(){
				this.$emit("submit",{type:'close'})
			},
			submit(){
				let params = {
					"typeId": "",
					"typeName": this.newValue,
					"parentId": this.tagItem===''?'':this.tagItem.id,
				}
				let loading = this.$loading()
				this.$http.post(process.env.VUE_APP_Url_baseData+'/api/tag/medicine/update', params).then(res => {
					loading.close()
					if(res.code===0){
						this.$emit("submit",{type:'success'})
						this.$message({
							message: '操作成功',
							type: 'success'
						});
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
</style>
